export const PERMS = {
    READ: 'report_pallets.read',
}
